<template>
  <a-card class="m-display-flex flex-column padding-unset">
    <span slot="title">{{ mode }} UM PD/S</span>
    <a-tag slot="extra" class="m-text-bold"
      >{{ countUm }}<sup>{{ ordinalNumber(countUm) }}</sup>
      &nbsp;down payment
    </a-tag>

    <div class="step">
      <div class="step-header">
        <a-steps :current="current" status="process">
          <a-step title="Information" />
          <a-step title="Detail" />
          <a-step title="Approval" />
        </a-steps>
      </div>
      <div class="step-content">
        <component
          class="m-flex1"
          :is="steps[current].content"
          :ref="stepRef"
          v-bind="stepProps"
        ></component>
      </div>
    </div>

    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button v-if="current < steps.length - 1" type="primary" @click="next"
          >Next</a-button
        >
        <a-button
          type="primary"
          v-if="current == steps.length - 1"
          :loading="loading.submit"
          @click="handleValidation"
        >
          Save
        </a-button>
        <a-button v-if="current > 0" @click="prev">Previous</a-button>
      </div>
    </template>
  </a-card>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import { Information, Detail } from "./steps";
import Approval from "./steps/Persetujuan.vue";

export default {
  name: "umpdCreate",
  props: ["id"],
  components: {
    Information,
    Detail,
    Approval,
  },
  mixins: [GlobalMethod, CurrencyFormat],
  data() {
    return {
      mode: "Create",
      countUm: "0",
      current: 0,
      isEdited: true,
      steps: [
        {
          title: "Information",
          content: "Information",
        },
        {
          title: "Detail",
          content: "Detail",
        },
        {
          title: "Approval",
          content: "Approval",
        },
      ],
      collectData: {
        information: {},
        detail: [],
        list_item: [],
      },
      loading: {
        submit: false,
        next: false,
      },
      limitRevisi: 0,
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getAllKaryawan",
      "getAllMataUang",
      "getStandartFormatDate",
    ]),
    stepRef: function() {
      if (this.steps[this.current].content === "Information") {
        return "refInformation";
      } else if (this.steps[this.current].content === "Detail") {
        return "refDetail";
      } else{
        return "refApproval";
      }
    },
    stepProps: function() {
      if (this.steps[this.current].content === "Information") {
        return {
          data: this.collectData.information,
          detail: this.collectData.detail,
          mode: this.mode,
        };
      } else if (this.steps[this.current].content === "Detail") {
        return {
          information: this.collectData.information,
          list_item: this.collectData.list_item,
          detailList: this.collectData.detail,
          mode: this.mode,
        };
      } else {
          return {
            collectData: this.collectData,
            mode: this.mode,
            listAppr: this.collectData.approval,
            id: this.id
          };
        }
    },
  },

  created() {
    if (this.id) {
      this.mode = "Edit";
      this.$store
        .dispatch("getUmpdById", { auth: this.getAuth, id: this.id })
        .then((res) => {
          this.collectData.information = {
            id_sppd: res.detail_um_pd[0].id_sppd,
            tgl_buat: moment(res.detail_um_pd[0].tanggal).format("DD-MM-YYYY"),
            end_user: res.detail_um_pd[0].end_user,
            mata_uang: res.detail_um_pd[0].mata_uang,
            kurs: res.detail_um_pd[0].kurs,
            estimate_value: res.detail_um_pd[0].estimate_value,
            atasan_langsung: res.detail_um_pd[0].atasan_langsung,
            bod: res.detail_um_pd[0].approval_bod,
            catatan: res.detail_um_pd[0].catatan,
            deskripsi: res.detail_um_pd[0].deskripsi,
          };
          this.limitRevisi = parseFloat(res.detail_um_pd[0].estimate_value)*parseFloat(res.detail_um_pd[0].kurs)
          this.countUm = res.detail_um_pd[0].seq;
          this.collectData.detail = res.dtl_um;
        });
    }
  },
  methods: {
    moment,
    next() {
      this.loading.next = true;
      if (this.steps[this.current].content === "Information") {
        this.$refs.refInformation.handleRef();
      } else if (this.steps[this.current].content === "Detail") {
        this.$refs.refDetail.handleRef();
        if (this.collectData.detail.length==0){
        this.displayMessageValue("error-other", "Detail UMPD can't be empty!");
        } else {
          this.getApproval();
        }
      } else{
        this.$refs.refApproval.handleRef();
      }
    },
    prev() {
      if (this.steps[this.current].content === "Detail") {
        this.$refs.refDetail.handleRef();
        this.current = 0;
      } if (this.steps[this.current].content === "Approval") {
        this.$refs.refApproval.handleRef();
        this.current--;
      }
    },
    async fetchDetailList(id_sppd) {
      await this.$store
        .dispatch("getItemDetailSppd", {
          data: this.getAuth,
          id_sppd: id_sppd,
        })
        .then((result) => {
          this.collectData.list_item = result.list_nama_item;
        });
    },
    handleChildValue(value) {
      if (this.steps[this.current].content === "Information") {
        this.collectData.information = value;
        if (this.mode == "Edit") {
          if (this.collectData.list_item.length == 0) {
            this.fetchDetailList(value.id_sppd).then(() => {
              this.current++;
            });
          } else {
            this.current++;
          }
        } else {
          this.fetchDetailList(value.id_sppd).then(() => {
            this.current++;
          });
        }
      } else if (this.steps[this.current].content === "Detail") {
        this.collectData.detail = value.detail;
        this.collectData.grandTotal = value.grandTotal;
      }else{
        this.collectData.information.catatan = value.note;
      }

      this.loading.next = false;
    },
    handleValidation() {
      this.$refs.refApproval.handleRef();
      this.handleValidationProcess();
    },
    handleValidationProcess() {
      if (this.mode=="Edit"){
        let grandtotal = 0;
        this.collectData.detail.forEach((item) => {
          grandtotal = grandtotal + parseFloat(item.value);
        });
        let flagSave = parseFloat(this.limitRevisi)>=50000000
        let flagnom = grandtotal*parseFloat(this.collectData.information.kurs)>=50000000
        if(flagSave!==flagnom){
          flagSave 
          ? this.displayMessageValue("error-other", "Grand Total of modified data must not be less than Rp.50.000.000!")
          : this.displayMessageValue("error-other", "Grand Total of modified data should not be more than Rp.50.000.000!")
          return
        }
      }
      this.confirmMessage("confirm-save");
    },
    downPayment(item) {
      this.countUm = item;
    },
    submit() {
      //this.$refs.refDetail.saveList();

      if (this.collectData.detail.length == 0) {
        alert("tambahkan detail terlebih dahulu!");
      } else {
        let sppd_dtl = [];
        let item_name = [];
        let value = [];
        let grandtotal = 0;
        let idumdetil=[];

        this.collectData.detail.forEach((item) => {
          sppd_dtl.push(item.idSppdDtl);
          item_name.push(item.itemName);
          value.push(item.value);
          grandtotal = grandtotal + parseFloat(item.value);
          idumdetil.push(item.id_um_dtl);
        });

        let data = {
          tlc: this.getAuth.username,
          no_sppds: this.collectData.information.no_sppd,
          tanggal: this.moment(
            this.collectData.information.tgl_buat,
            "DD-MM-YYYY"
          ).format("YYYY-MM-DD"),
          end_user: this.collectData.information.end_user,
          mata_uang: this.collectData.information.mata_uang,
          kurs_to_idr: this.collectData.information.kurs,
          deskripsi: this.collectData.information.deskripsi,
          catatan: this.collectData.information.catatan,
          sppd_dtl: sppd_dtl,
          item_name: item_name,
          value: value,
          id_um: this.id,
          id_um_dtl: idumdetil,
        };

        axios({
          method: this.mode == "Create" ? "post" : "put",
          url: this.$serviceUrl + "um_pd/v2",
          data: data,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.displayMessage("success-save");
            this.$router.push({ name: "umpd" });
          })
          .catch((err) => {
            let response = Object.assign({}, err.response.data);
            if (response.status == false){
              this.displayMessageValue("error-other", response.message);
            }else{
              this.displayMessageValue("error", err)
            }
          });
      }
    },
    async getApproval(){
      let params = null;
      if (this.mode=="Create"){
        params = {
          no_sppds : this.collectData.information.no_sppd,
          value : this.collectData.grandTotal,
          kurs_to_idr : this.collectData.information.kurs,
        }
      }else{
        params = {
          no_sppds : this.collectData.information.no_sppd,
          value : this.collectData.grandTotal,
          kurs_to_idr : this.collectData.information.kurs,
          id_um : this.collectData.detail[0].id_um,
        }
      }
      await axios({
        method: 'get',
        url: this.$serviceUrl + "um_pd/approval",
        processData: false,
        params: params,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.collectData.approval=response.data.data;
          this.current++;
        })
        .catch(err => {
          let responses = Object.assign({}, err.response);
          this.displayMessageValue("error", responses);
        });
    },
  },

  mounted() {
    Event.$on("confirmMessageReturn", this.submit);
    Event.$on("handleChildValue", this.handleChildValue);
    Event.$on("downPayment", this.downPayment);
  },

  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.submit);
    Event.$off("handleChildValue", this.handleChildValue);
    Event.$off("downPayment", this.downPayment);
  },
};
</script>

<style lang="less">
.step {
  border: 1px solid darken(white, 10);
  flex: 1;
  display: flex;
  flex-direction: column;
  &-header {
    padding: @padding;
    background-color: darken(white, 2);
    border-bottom: 1px solid darken(white, 10);
  }
  &-content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.padding-unset {
  .ant-card-body {
    padding: 0 !important;
  }
}

.ant-card-extra{
  margin-left: 0px!important;
}
</style>
